<template>
  <b-container>
    <DeleteKPIModal
      :kpi="toBeEditedKPI"
      @kpi-deleted="fetchLevelKPIs"
    />
    <LevelKPIForm
      :kpi="toBeEditedKPI"
      @refetch="fetchLevelKPIs"
    />
    <LevelRewardForm
      :reward="toBeEditedReward"
      @refetch="fetchLevelRewards"
    />
    <b-row>
      <b-col md="12">
        <b-card>
          <b-card-title>Level Details</b-card-title>
          <base-overlay :show="fetchingDetails">
            <b-container v-if="levelDetails">
              <b-row
                v-for="(item, ix) in pickFromDetails"
                :key="ix"
                class="mb-2"
              >
                <b-col
                  cols="4"
                  class="font-weight-bold"
                >
                  {{ item.label }}
                </b-col>
                <b-col cols="8">
                  {{ getNestedValue(levelDetails, item.key) }}
                </b-col>
              </b-row>
            </b-container>
          </base-overlay>
        </b-card>
      </b-col>
      <b-col md="12">
        <b-card>
          <div class="d-flex justify-content-between align-items-center mb-1">
            <h4>Level KPIs</h4>
            <b-button
              variant="primary"
              @click="newKPIhandler"
            >
              Create New KPI
            </b-button>
          </div>
          <base-overlay :show="fetchingKPIs">
            <b-table
              :fields="kpisTableColumns"
              :items="levelKpis"
              striped
              hover
              responsive
              show-empty
              empty-text="No KPIs found"
            >
              <template #cell(actions)="data">
                <div class="d-flex align-items-center">
                  <b-button
                    variant="flat-primary"
                    @click="editKPIHandler(data.item)"
                  >
                    <feather-icon icon="EditIcon" />
                  </b-button>
                  <b-button
                    variant="flat-danger"
                    @click="deleteKPIHandler(data.item)"
                  >
                    <feather-icon icon="TrashIcon" />
                  </b-button>
                </div>
              </template>
            </b-table>
          </base-overlay>
        </b-card>
      </b-col>
      <b-col md="12">
        <b-card>
          <div class="d-flex justify-content-between align-items-center mb-1">
            <h4>Level Rewards</h4>
            <b-button
              variant="primary"
              @click="newRewardHandler"
            >
              Create New Reward
            </b-button>
          </div>
          <base-overlay :show="fetchingRewards">
            <b-table
              :fields="rewardsTableColumns"
              :items="levelRewards"
              striped
              hover
              responsive
              show-empty
              empty-text="No rewards found"
            >
              <template #cell(actions)="data">
                <div class="d-flex align-items-center">
                  <b-button
                    variant="flat-primary"
                    @click="editRewardHandler(data.item)"
                  >
                    <feather-icon icon="EditIcon" />
                  </b-button>
                </div>
              </template>
            </b-table>
          </base-overlay>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {
  BCard, BRow, BCol, BContainer, BCardTitle, BTable, BButton,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import axiosIns from '@/libs/axios'
import BaseOverlay from '@/UI/BaseOverlay.vue'
import formatDate, { dateFormat } from '@/utils/date-format'
import snakeCaseToCamelCase from '@/utils/snake-case-to-camcel-caase'
import LevelKPIForm from '../components/LevelKPIForm.vue'
import LevelRewardForm from '../components/LevelRewardForm.vue'
import DeleteKPIModal from '../components/DeleteKPIModal.vue'

const getNestedValue = (obj, key) => key.split('.').reduce((acc, curr) => acc && acc[curr], obj)

export default {
  components: {
    BCard,
    BContainer,
    BTable,
    BRow,
    BCardTitle,
    LevelKPIForm,
    BCol,
    DeleteKPIModal,
    BaseOverlay,
    BButton,
    LevelRewardForm,
  },
  setup(_, ctx) {
    const pickFromDetails = [
      {
        label: 'Name EN',
        key: 'name.en',
      },
      {
        label: 'Name AR',
        key: 'name.ar',
      },
      {
        label: 'Description EN',
        key: 'description.en',
      },
      {
        label: 'Description AR',
        key: 'description.ar',
      },
      {
        label: 'Sort',
        key: 'sort',
      },
      {
        label: 'Zone',
        key: 'zone',
      },
    ]
    const levelID = ctx.root.$route.params.id
    const fetchingDetails = ref(false)
    const fetchingKPIs = ref(false)
    const fetchingRewards = ref(false)

    const levelDetails = ref()
    const kpisTableColumns = [
      {
        label: 'Name English',
        key: 'nameEn',
        formatter: (_1, _2, item) => item.name.en,
      },
      {
        label: 'Name Arabic',
        key: 'nameAr',
        formatter: (_1, _2, item) => item.name.ar,
      },
      {
        label: 'No. of trips',
        key: 'numberOfTrips',
        formatter: (_1, _2, item) => item.configuration.numberOfTrips,
      },
      {
        label: 'Period',
        key: 'period',
        formatter: (_1, _2, item) => snakeCaseToCamelCase(item.configuration.period),
      },

      {
        label: 'created at',
        key: 'createdAt',
        formatter: val => formatDate(val),
      },
      {
        label: 'Effective Time',
        key: 'effectiveTime',
        formatter: val => dateFormat(val),
      },
      'actions',
    ]
    const levelKpis = ref()
    const levelRewards = ref()
    const rewardsTableColumns = [
      {
        label: 'Name English',
        key: 'nameEn',
        formatter: (_1, _2, item) => item.name.en,
      },
      {
        label: 'Name Arabic',
        key: 'nameAr',
        formatter: (_1, _2, item) => item.name.ar,
      },
      {
        label: 'amount',
        key: 'amount',
        formatter: (_1, _2, item) => item.configuration.amount,
      },
      {
        label: 'Beneficiary',
        key: 'beneficiary',
        formatter: val => snakeCaseToCamelCase(val),
      },

      {
        label: 'created at',
        key: 'createdAt',
        formatter: val => formatDate(val),
      },
      'actions',
    ]

    const fetchLevelDetails = async () => {
      fetchingDetails.value = true
      const levelResult = await axiosIns.get(`/teams/levels/${levelID}`)
      levelDetails.value = levelResult.data.data
      fetchingDetails.value = false
    }

    const fetchLevelKPIs = async () => {
      fetchingKPIs.value = true
      const kpisResult = await axiosIns.get(`/teams/kpis?levelId=${levelID}`)
      levelKpis.value = kpisResult.data.data
      fetchingKPIs.value = false
    }

    const fetchLevelRewards = async () => {
      fetchingRewards.value = true
      const rewardsResult = await axiosIns.get(`/teams/rewards?levelId=${levelID}`)
      levelRewards.value = rewardsResult.data
      fetchingRewards.value = false
    }
    fetchLevelDetails()
    fetchLevelKPIs()
    fetchLevelRewards()

    const toBeEditedKPI = ref()

    const newKPIhandler = () => {
      toBeEditedKPI.value = undefined
      ctx.root.$bvModal.show('level-kpi-form-modal')
    }

    const editKPIHandler = kpi => {
      toBeEditedKPI.value = kpi
      ctx.root.$bvModal.show('level-kpi-form-modal')
    }

    const toBeEditedReward = ref()

    const newRewardHandler = () => {
      toBeEditedReward.value = undefined
      ctx.root.$bvModal.show('level-reward-form-modal')
    }

    const editRewardHandler = reward => {
      toBeEditedReward.value = reward
      ctx.root.$bvModal.show('level-reward-form-modal')
    }

    const deleteKPIHandler = kpi => {
      console.log(kpi)
      toBeEditedKPI.value = kpi
      ctx.root.$bvModal.show('delete-kpi-modal')
    }

    return {
      fetchingKPIs,
      fetchingDetails,
      levelID,
      fetchLevelKPIs,
      toBeEditedReward,
      deleteKPIHandler,
      newRewardHandler,
      editRewardHandler,
      rewardsTableColumns,
      toBeEditedKPI,
      levelRewards,
      kpisTableColumns,
      levelDetails,
      levelKpis,
      pickFromDetails,
      getNestedValue,
      fetchLevelDetails,
      editKPIHandler,
      fetchingRewards,
      fetchLevelRewards,
      newKPIhandler,
    }
  },
}
</script>
